import { collectionEngineV1, drainPages } from '../apis.js';
const caseGroupsAPI = collectionEngineV1('/case-groups');
const PAGE_SIZE = 500;
// Pages to the end so callers keep getting the full set.
export const getAllCaseGroups = () => drainPages((page) => caseGroupsAPI('GET', `/?page=${page}&pageSize=${PAGE_SIZE}`), PAGE_SIZE);
export const createCaseGroup = (body) => caseGroupsAPI('POST', `/`, { body });
export const delCaseGroup = (id) => caseGroupsAPI('DELETE', `/${id}`);
export const patch = (id, patch) => caseGroupsAPI('PATCH', `/${id}`, {
    body: patch,
});
//# sourceMappingURL=case-groups.js.map